//hamburger
const toggleGlobalNav = () => {

    const hamburger = document.getElementById('js-hamburger');

    if (!hamburger) return;

    const body = document.body;

    hamburger.addEventListener('click', () => {
        body.classList.toggle('is-gnav-active');
    })

}
toggleGlobalNav();

//open naviが開いたまま画面幅が大きくなった時にis-gnavi-activeを外す
const removeGlobalNav = () => {
    const body = document.body;
    const matchMedia = window.matchMedia('(min-width: 992px)');

    matchMedia.onchange = (e) => {
        if (e.matches) {
            if (body.classList.contains('is-gnav-active') == true) {
                body.classList.remove('is-gnav-active');
            }
        }
    }
}
removeGlobalNav();

//open naviのアコーディオンメニューを開閉
const accordionToggle = () => {
    const target = document.getElementsByClassName('menu-item-has-children');

    [...target].forEach((e) => {
        e.addEventListener('click', () => {
            e.classList.toggle('is-accordion-active')
        })
    });
}
accordionToggle();

const openSearch = () => {
    const openBtn = document.getElementsByClassName('js-open-search');
    const searchArea = document.getElementById('js-search-area');

    if(!openBtn || !searchArea) return;

    [...openBtn].forEach(elem => {
        elem.addEventListener('click', () => {
            searchArea.classList.add('search-is-open');
        })
    })
}

openSearch();

const closeSearch = () => {
    const closeBtn = document.getElementsByClassName('js-close-search');
    const searchArea = document.getElementById('js-search-area');

    if(!closeBtn || !searchArea) return;

    [...closeBtn].forEach(elem => {
        elem.addEventListener('click', () => {
            searchArea.classList.remove('search-is-open');
        })
    })
}
closeSearch();